import { FC } from "react";
import { CurrencySmallIcon } from "../../../CurrencySmallIcon/CurrencySmallIcon";
import { Ticket, TicketType } from "../../../TicketsPanel/Ticket";
import styles from "./NoReferalsBehaviorNotify.module.scss";
import { Button } from "../../../Buttons/Button/Button";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../Menu/MenuButton";
import { ActionsContext } from "../../../../pages/ActionsPage/ACtionsRoutes";
import { TaskContext } from "../../../../pages/TaskPage/TasksTypes";
import fragmentIcon from "../../../../icons/fragment.png";
import { Modal } from "../../Modal";

interface INoReferalsBehaviorNotifyProps {
    closeHandler: () => void;
}

export const NoReferalsBehaviorNotify: FC<INoReferalsBehaviorNotifyProps> = ({ closeHandler }) => {
    const navigate = useNavigate();

    const handler = () => {
        closeHandler();
        navigate(`${AppContext.Actions}/${ActionsContext.Tasks}/${TaskContext.Invite}`);
    };

    const getFragmentIcon = () => <img className={styles.fragmentImage} src={fragmentIcon} alt='fragment' />;

    const message = (
        <div className={styles.text}>
            <p>Знаете ли вы, что 92% победителей розыгрыша сертификата на 2 000 руб. приглашают друзей.</p>
            <p>Просто поделитесь своей реферальной ссылкой или разместите её в соцсетях — и получайте награды:</p>
            <p className={styles.list}>
                <div>1. 10% c сертификата друга в виде {getFragmentIcon()}.</div>
                <div className={styles.currencyItem}>2. <CurrencySmallIcon value={500000} /> за регистрацию друга.</div>
                <div>3. {getFragmentIcon()} 2 фрагмента за опыт друга.</div>
                <div>
                    4. <span className={styles.ticketsBlock}>
                        <Ticket type={TicketType.Epic} value={19} precission={0} postfix=" билетов за опыт друга." context='modal' />
                    </span>
                </div>
            </p>
        </div>
    );

    return (
        <Modal
            name='NoReferalsBehaviorNotify'
            title='Подсказка'
            message={message}
            button={<Button caption='Пригласить' type='green' handler={handler} />}
            closeCross={{ onClose: closeHandler }}
        />
    );
};